<template>
  <div class="policy">
      <div class="header">
        <h1 class="title"><i class="icon"></i>TEAPOTエディタ</h1>
      </div>
      <h2>個人情報保護方針 <span>PRIVACY POLICY</span></h2>
      <div class="txtBox">
        <p>
            合同会社想実堂（以下「当社」といいます）は、スマートフォンアプリケーション上で提供するサービスTEAPOTエディタ（以下「本サービス」といいます）における、アプリケーションの利用者（以下「ユーザー」といいます）の個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。
            <br>
            <br>
            <span>第1条（個人情報）</span>
            <br>
            「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
            <br>
            <br>
            <span>第2条（個人情報の収集方法）</span>
            <br>
            本アプリは、アプリの利用状況データを収集するツールとしてFirebase(Google Inc.)を使用しており、Firebaseがご利用者の情報を自動取得する場合がございます。取得する情報、利用目的、第三者への提供などにつきましては、以下のGoogleプライバシーポリシーをご確認ください。
            <br>
            <br>
            Google プライバシーポリシー
            <br>
            <a href="https://policies.google.com/technologies/ads?hl=ja">https://policies.google.com/technologies/ads?hl=ja</a>
            <br>
            <br>
            <span>第3条（個人情報を収集・利用する目的）</span>
            <br>
            当社が個人情報を収集・利用する目的は、以下のとおりです。
            <br>
            <br>
            当社サービスの提供・運営のため
            <br>
            ユーザーからのお問い合わせに回答するため
            <br>
            上記の利用目的に付随する目的
            <br>
            <br>
            <span>第4条（利用目的の変更）</span>
            <br>
            当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。
            <br>
            <br>
            <span>第5条（プライバシーポリシーの変更）</span>
            <br>
            本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。
            <br>
            当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点で効力を生じるものとします。
            <br>
            <br>
            <span>第6条（お問い合わせ窓口）</span>
            <br>
            本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
            <br>
            <br>
            合同会社想実堂
            <br>
            〒116-0003東京都荒川区南千住1-5-6
            <br>
            support@sojitsudo.com
        </p>
      </div>
  </div>
</template>

<style>
html, body {
  height: 100%;
}
body {
  display: block;
  margin: 0;
  padding: 0;
  bottom:0;
  overflow-x: hidden;
  position: relative;
  font-weight: normal;
  font-family: Meiryo, "メイリオ", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", sans-serif;
}
div {
  padding: 0;
  background: transparent;
  border: 0;
  outline: 0;
}
span {
    margin: 0;
    padding: 0;
    background: transparent;
    border: 0;
    outline: 0;
}
.policy {
  background: white;
  margin: 0 auto;
  padding:0 10px 40px;
  width: auto;
  max-width: 700px;
  text-align: left;
}
.header {
  background-size: 1px 3px;
  z-index: 2500;
  position: relative;
  display: block;
}
.header h1 {
  font-size: 25px;
  font-weight: bold;
  margin: 30px 0px 10px 0px;
}
.header h1 .icon {
  display: inline-block;
  width: 25px;
  height: 25px;
  margin-right: 10px;
  background-image: url(../assets/logo.png);
  background-size: contain;
  background-repeat:  no-repeat; 
}
.policy p {
  font-size: 15px;
}
.policy h2 {
    display: block;
    margin-bottom: 40px;
    color: #fff;
    background: #55007f;
    padding: 15px;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 3px;
    border-left: 5px solid #3c0259;
}
.policy h2 span {
    color: #6b2090;
    float: right;
    font-size: 16px;
    letter-spacing: 1px;
}
.txtBox p {
    margin-left: 3px;
    font-size: 13px;
    line-height: 1.6;
}
.txtBox span {
    color: #000;
    font-size: 16px;
    font-weight: bold;
}
.footer {
  padding-top: 20px;
  text-align: center;
  background-color: #55007f;
  margin-top: 100px;
  display: block;
  border: 0;
  outline: 0;
  font-size: 100%;
  font-weight: normal;
}
.footer ul {
  display: block;
  list-style: none;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
  margin: 0;
  padding: 0;
  background: transparent;
  border: 0;
  outline: 0;
  font-size: 1em;
  font-weight: normal;
}
.footer li {
  display: inline-block;
  font-size: 11px;
  margin: 0;
  padding: 0;
  background: transparent;
  border: 0;
  outline: 0;
  font-weight: normal;
  vertical-align: baseline;
  text-align: -webkit-match-parent;
}
.footer li a {
  margin: 0 6px 0 3px;
  text-decoration: none;
  color: #fff;
  background: transparent;
  font-size: 1em;
  transition-property: background-color, border-color, color, opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease;
  font-weight: normal;
  vertical-align: baseline;
}
a:-webkit-any-link {
  cursor: pointer;
}
.footer p {
  padding: 8px;
  font-size: 10px;
  color: #FFF;
  background-color: #55007f;
}
</style>